<form class="m-1">
    <div class="row" [ngBusy]="{
        busy: busySave,
        message: 'Veuillez patienter ...',
        backdrop: false
    }">

        <div class="row">

            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <ng-container>
                    <div class="details-info-part">
                        <div class="row">

                            <div class="col-md-2 col-sm-6 mb-3">
                                <label>N°Prelevement :</label>
                                <input class="form-control custom-input" placeholder="N°Prelevement" autocomplete="off"
                                    [(ngModel)]="currentAccueil.libelle" [disabled]="true" name="numRecuTicket" required
                                    type="text" />
                            </div>

                            <div class="col-md-2 col-sm-6 mb-3">
                                <label>Date heure :</label>
                                <input class="form-control custom-input" placeholder="" autocomplete="off"
                                    [(ngModel)]="currentAccueil.createdAt" [disabled]="true" name="numRecuTic" required
                                    type="text" />
                            </div>

                            <div class="col-md-2 col-sm-6 mb-3">
                                <label>N°Acceuil :</label>
                                <input class="form-control custom-input" placeholder="N°Acceuil" autocomplete="off"
                                    [(ngModel)]="currentAccueil.code" name="numAcceuil" [disabled]="true" required
                                    type="text" />
                            </div>

                            <div class="col-md-3 col-sm-6 mb-3">
                                <label>Medecin prescription : </label>
                                <input class="form-control custom-input" placeholder="" autocomplete="off"
                                    [(ngModel)]="currentPrelevement.dataReception.medecinPrescripteur" disabled name="medecinPrescription"
                                    style="text-transform: uppercase" type="text" />
                            </div>

                            <div class="col-md-3 col-sm-6 mb-3">
                                <label>Unité fonctionnelle : </label>
                                <input class="form-control custom-input" placeholder="Unité fonctionnelle"
                                    autocomplete="off" [(ngModel)]="currentAccueil.adminUniteFonctionnelleLibelle"
                                    [disabled]="true" name="uniteFonctionnelle" required type="text" />
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-12 mb-3">
                                <fieldset class="custom-fieldset">
                                    <legend>Infos patient</legend>

                                    <div class="col-12">
                                        <app-info-patient-consultation
                                            [idPatient]="currentAccueil?.patientId"></app-info-patient-consultation>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>

                </ng-container>
            </div>

            <div class="row mt-3">

                <div class="col-12 mb-3">
                    <fieldset class="custom-fieldset">
                        <legend>Ajouter des Documents </legend>
                        <div class="col-12">
                            <app-add-document (addDocument)="getCurrentDocument($event)">
                            </app-add-document>
                        </div>
                    </fieldset>
                </div>

                 <div class="col-12 mb-3" *ngIf="currentPrelevement?.datasBulletin">
                    <fieldset class="custom-fieldset">
                        <legend>Documents déjà ajoutés </legend>
                        <div class="row">
                          <div class="col-12">
                             <app-add-document-fiche-engagement [isReadOnly]="true" [defaultDocuments]="currentPrelevement?.datasBulletin"></app-add-document-fiche-engagement>
                          </div>
                        </div>
                    </fieldset>
                </div>

            </div>

            <div class="row btn-manger-part">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <button type="button" class="btn btn-md custom_btn_primary pull-right" (click)="confirmSaveItem()">
                        Enregistrer
                    </button>

                    <button type="button" class="btn btn-md btn-cancel pull-right" (click)="handleClose()">
                        Fermer
                    </button>
                </div>
            </div>

        </div>
    </div>
</form>